import { CountUp } from 'countup.js';

export const numbers = () => {
  const numbers = document.querySelectorAll('span.number');

  const animateNumber = (element, start, end, duration) => {
    let startTime = null;

    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const currentNumber = Math.floor(progress * (end - start) + start);
      element.textContent = currentNumber.toLocaleString();
      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  };

  const observerOptions = {
    root: null, // Use the viewport as the root
    threshold: 0.1, // Trigger when 10% of the element is visible
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const numberElement = entry.target;
        const endValue = parseInt(numberElement.textContent.replace(/,/g, ''));
        animateNumber(numberElement, 0, endValue, 2000); // Animate over 2 seconds
        observer.unobserve(numberElement); // Stop observing once animation is triggered
      }
    });
  }, observerOptions);

  numbers.forEach((number) => {
    observer.observe(number);
  });
};
